export const actionTypes = {
  CONSULTATION_ID_CHECK_SAVE: "CONSULTATION_ID_CHECK_SAVE",
};

export const saveConsultationIdCheck = (payload) => {
  return { type: actionTypes.CONSULTATION_ID_CHECK_SAVE, payload };
};
